import httpRequest from "@/auth/http-client";
import { buildPaginationQuery } from "@/helpers/request-helpers";
import { IServiceHours, IServiceHoursInput } from "@/interfaces/service-hours.interface";
import { IFilter } from "@/types/filter.types";
import { PaginatedResponse, RequestPagination } from "@/types/requests.types";

class ServiceHoursService {
  private baseUrl = "api/v1/servicehours";

  async getAll(pagination: RequestPagination): Promise<PaginatedResponse<IServiceHours>> {
    const paginationQuery = buildPaginationQuery(pagination);
    return await httpRequest.get(`${this.baseUrl}?${paginationQuery}`);
  }

  async filter(
    filter: IFilter<IServiceHours>[],
    pagination: RequestPagination
  ): Promise<PaginatedResponse<IServiceHours>> {
    const paginationQuery = buildPaginationQuery(pagination);
    return await httpRequest.post(`${this.baseUrl}/filter?${paginationQuery}`, { filter });
  }

  async create(formData: IServiceHoursInput): Promise<void> {
    return await httpRequest.post(this.baseUrl, formData);
  }

  async getById(id: number): Promise<IServiceHours> {
    return await httpRequest.get(`${this.baseUrl}/${id}`);
  }

  async update(formData: IServiceHoursInput, id: number): Promise<void> {
    await httpRequest.put(`${this.baseUrl}/${id}`, formData);
  }

  async delete(id: number): Promise<void> {
    await httpRequest.delete(`${this.baseUrl}/${id}`);
  }
}

const serviceHoursService = new ServiceHoursService();
export default serviceHoursService;
